export function development(fn: () => void): void {
    if (process.env.NODE_ENV === "development" && typeof fn === "function") {
        fn();
    }
}
